import dayjs from 'dayjs';
import { getRuntimeEnv } from '@utils/runtimeEnv';

/**
 * Returns the effective month (YYYY-MM) for editing — the previous month if
 * before the last day of the current month, otherwise the current month.
 * This mirrors the logic in useMeterReadDetailsTableMonthCell.
 */
export function getEffectiveMonthYear(): string {
  const today = dayjs();
  const effectiveDate = today.date() < today.daysInMonth()
    ? today.subtract(1, 'month')
    : today;
  return effectiveDate.format('YYYY-MM');
}

/**
 * Returns true when REACT_APP_BLADE_MONTH_EDITABLE=true is set.
 * Enables the month/year picker inside blade components for testing purposes.
 * In production this should be false so blades lock to the effective month.
 */
export function isBladeMonthEditable(): boolean {
  return getRuntimeEnv('REACT_APP_BLADE_MONTH_EDITABLE') === 'true';
}
